import React, { useEffect, useRef, useState } from "react";
import BannerComp from "../Components/BannerComp";
import Header from "../Components/Header";
import { Empty, Image, Pagination, Spin } from "antd";
import image5 from "../Assets/Photos & Videos/IMG-20190113-WA0028.jpg";
// import video1 from "../Assets/Photos & Videos/Untitled video - Made with Clipchamp.mp4";
// import video2 from "../Assets/Photos & Videos/WhatsApp Video 2021-06-02 at 12.17.48 PM.mp4";
// import video3 from "../Assets/Photos & Videos/WhatsApp Video 2023-11-23 at 4.30.03 PM (1).mp4";

import { MdOutlineRemoveRedEye } from "react-icons/md";
import Footer from "../Components/Footer";
import { get } from "../apiService";
import { IoMdPause } from "react-icons/io";
import { FaExpand } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
import { MetaTags } from "react-meta-tags";

export default function Gallery() {
  const [visible, setVisible] = useState({ image: "", isVisible: false });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 9,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [pagination.current, pagination.pageSize]);

  const fetchData = async (current, pageSize, search) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/gallery.php?limit=${pageSize}&page=${current}&action=${action}${search ? "&search=" + search + "" : ""
        }`
      );
      setAllData(response?.message?.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response?.message?.total,
      }));
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const [isPlaying, setIsPlaying] = useState({}); // State to track playing status of each video
  const videoRefs = useRef([]);

  const handlePlay = (index) => {
    setIsPlaying((prev) => ({
      ...prev,
      [index]: true, // Set the specific video to playing
    }));
    if (videoRefs.current[index]) {
      videoRefs.current[index].play(); // Play the video at the given index
    }
  };

  const handlePause = (index) => {
    setIsPlaying((prev) => ({
      ...prev,
      [index]: false, // Set the specific video to paused
    }));
    if (videoRefs.current[index]) {
      videoRefs.current[index].pause(); // Play the video at the given index
    }
  };

  const expandVideo = (index) => {
    if (videoRefs.current[index]) {
      videoRefs.current[index].requestFullscreen();
    }
  };

  return (
    <>

      <MetaTags>
        <title>Fancy Color Diamonds | Sejal Exports</title>
        <meta title="Fancy Color Diamonds | Sejal Exports" />
        <meta name="description" content="Discover the allure of Fancy Color Diamonds, featuring vibrant hues that make each stone unique. Perfect for exceptional jewellery designs." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/fancy-color-diamonds" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Fancy Color Diamonds | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content="Discover the allure of Fancy Color Diamonds, featuring vibrant hues that make each stone unique. Perfect for exceptional jewellery designs." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>

      <Header />
      <BannerComp
        title="Life At Sejal"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Gallery",
          },
        ]}
        image={image5}
      />
      <Spin spinning={loading}>
        {allData.length > 0 ? (
          <>
            <section className="sectionDiv">
              <div className="container">
                <div className="row">
                  {allData.map((val, index) => (
                    <div className="col-md-4 mb-4" key={index}>
                      {val.type === "Image" ? (
                        <div
                          className="galleryImage"
                          onClick={() =>
                            setVisible({
                              image: val.file_path,
                              isVisible: true,
                            })
                          }
                        >
                          <img
                            alt="Fancy Color Diamonds"
                            style={{
                              width: "100%",
                              minHeight: "280px",
                              height: "280px",
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                            src={val.file_path}
                          />
                          <MdOutlineRemoveRedEye />
                        </div>
                      ) : (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            margin: "10px",
                          }}
                        >
                          <video
                            ref={(el) => (videoRefs.current[index] = el)} // Assign each video element to its own ref
                            preload="metadata"
                            // onPause={() => handlePause(index)}
                            onEnded={() => handlePause(index)}
                            style={{ width: "100%" }}
                          >
                            <source src={val.file_path} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>

                          {!isPlaying[index] && (
                            <button
                              onClick={() => handlePlay(index)}
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                backgroundColor: "rgba(0, 0, 0, 0.9)",
                                color: "white",
                                border: "none",
                                width: "50px",
                                height: "50px",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50px",
                              }}
                            >
                              <FaPlay />
                            </button>
                          )}
                          {isPlaying[index] && (
                            <div
                              style={{
                                position: "absolute",
                                top: "10px",
                                left: "20px",
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                onClick={() => handlePause(index)}
                                style={{
                                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                                  color: "white",
                                  border: "none",
                                  width: "40px",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  borderRadius: "50px",
                                }}
                              >
                                <IoMdPause />
                              </button>
                              {/* <button
                                onClick={() => expandVideo(index)}
                                style={{
                                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                                  color: "white",
                                  border: "none",
                                  width: "40px",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  borderRadius: "50px",
                                }}
                              >
                                <FaExpand />
                              </button> */}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </section>
            <div className="d-flex w-100 justify-content-center">
              <Pagination
                className="mt-4"
                current={pagination.current}
                onChange={(page) =>
                  setPagination((prev) => ({ ...prev, current: page }))
                }
                total={pagination.total}
              />
            </div>
          </>
        ) : (
          <Empty className="my-5" />
        )}
      </Spin>

      <Image
        width={200}
        style={{ display: "none" }}
        src={`${visible.image}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
        preview={{
          visible: visible.isVisible,
          src: visible.image,
          onVisibleChange: (value) => {
            setVisible((prev) => ({ image: "", isVisible: false }));
          },
        }}
      />
      <Footer />
    </>
  );
}
